import { Box, Checkbox, Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { DadosTermo } from "../../types";
import { LocalStorage } from "src/framework/commons/LocalStorage";
import moment from "moment";
import { useEffect, useState } from "react";

interface TermosProjetoProps {
  checked: boolean;
  setChecked: (status: boolean, dados: DadosTermo) => void
}

const useStyles = makeStyles({
  checkbox: {
    padding: 0
  }
})

export const TEXTOS_FINALIZAR = [
  {
    checked: false,
    texto: 'Declaro estar ciente e de acordo que a configuração do projeto, incluindo todos os componentes do gerador, estão de acordo com os requisitos exigidos pelas normas vigentes, concessionária ou cooperativa local, sendo eu o responsável por quaisquer alterações feitas na solução.'
  },
  {
    checked: false,
    texto: 'Estou ciente de que, dependendo dos produtos selecionados, podem ser empregados componentes não fabricados pela Intelbras, com garantia diferenciada, ou que componentes com as mesmas características possam ter sido utilizados em fases anteriores do projeto. Para mais informações, é necessário consultar a Política de Pós-Vendas da empresa.'
  }
];

function TermosProjeto({ checked, setChecked }: TermosProjetoProps) {
  const userInfo = LocalStorage.get("solar.userExtraInfo", true)
  const classes = useStyles();
  const [textosState, setTextosState] = useState(TEXTOS_FINALIZAR);

  useEffect(() => {
    if (checked) {
      const _textosState = [...textosState];
      
      for (const idx in _textosState) {
        _textosState[idx].checked = checked;
      }
      
      setTextosState(_textosState);
    }
  }, [checked]);

  return (
    <Box width='100%'  py={2} borderRadius="8px" bgcolor='#61616121' borderLeft={"10px solid #8BE68A"}>
      <Box display='flex' flexDirection={"column"}>
        <Box display='flex' paddingBottom={2}>
          <Box px={4}>
    
          </Box>
          <Box display='flex' flexDirection={"column"}>
            <Typography variant='body1' color='textPrimary' align="left">
              <strong>Termos do projeto</strong>
            </Typography>
          </Box>
        </Box>
        {textosState.map((e, index) => {
          return <>
            <Box display='flex' paddingBottom={2}>
              <Box px={3}>
                <Checkbox
                  checked={e.checked}
                  defaultChecked={e.checked}
                  onChange={() => {
                    const _textosState = [...textosState];

                    _textosState[index].checked = !e.checked;

                    const idx = _textosState.findIndex(e => e.checked === false);
                    const textosParse = _textosState.map(e => {
                      return e.texto;
                    });

                    setChecked(idx < 0, {texto: textosParse , aceito_em: moment().format("yyyy-MM-DD HH:mm:ss"), user_id: userInfo?.userId });

                    setTextosState(_textosState);
                  }}
                  color={"primary"}
                  className={classes.checkbox}
                />
              </Box>
              <Box display='flex' flexDirection={"column"}>
                <Typography variant='body2' color='textSecondary' align="left">{e.texto}</Typography>
              </Box>
            </Box>
          </>
        })}
      </Box>
    </Box>
  );
}

export { TermosProjeto }